
import {
  ConfigurationCell,
  ConfigurationCellMap,
  ICell,
  TParserParams
} from 'models/interfaces/spreadsheet-types/core-types';

interface Row {
  ignoreValidations?: boolean;
  [key: string]: any;
}

interface DefaultTitleParserProps {
  rows: Row[];
}

interface TitleCells {
  [key: string]: ICell;
}

const defaultTitleParser =  <I extends object, COLUMN extends object, TD extends object, CD extends object>(params: TParserParams<I, COLUMN, TD, CD>): ConfigurationCellMap<CD, I, COLUMN, TD> => {
  let titleCells: ConfigurationCellMap<CD, I, COLUMN, TD> = {};

  const { rows } = params
  
  const columnLegend = 'A';
  rows.forEach((row, rowIndex) => {
    const rowNumber = rowIndex + 1;
    const currentKey = `${columnLegend + rowNumber}`;
    const key = `TITLE_${columnLegend + rowNumber}`;

    const cell: ConfigurationCell<CD, I, COLUMN, TD> = {
      ...row,
      key: currentKey,
      value: row.value || '',
      expr: row.expr || '',
      columnLegend,
      rowNumber,
      ignoreValidations: row.ignoreValidations ?? true,
    };

    titleCells = {
      ...titleCells,
      [key]: cell,
    };
  });

  return titleCells;
};

export default defaultTitleParser;